import { useEffect, useState } from "react";

export const useTosUpdater = (termOfServices) => {
    const [isAllCheck, setAllCheck] = useState(false)
    const [checkedTosList, setCheckedTosList] = useState(null)
    const [requiredTosList, setRequiredTosList] = useState([])
    const [isValid, setValid] = useState(false)

    useEffect(() => {
        if (termOfServices == null) {
            return
        }

        const newCheckedTosList = {}
        const newRequiredTosList = {}

        termOfServices.forEach((tos) => {
            newCheckedTosList[tos.id] = false
            newRequiredTosList[tos.id] = tos.isRequired
        })

        setRequiredTosList(newRequiredTosList)
        setCheckedTosList(newCheckedTosList)
    }, [termOfServices])

    useEffect(() => {
        const newCheckedTosList = { ...checkedTosList }
        Object.keys(newCheckedTosList).forEach((tosId) => {
            newCheckedTosList[tosId] = isAllCheck
        })

        setCheckedTosList(newCheckedTosList)
    }, [isAllCheck])

    useEffect(() => {
        const validate = () => {
            if (checkedTosList == null) {
                return false
            }

            const isNotValid = Object.keys(checkedTosList).some((tosId) =>
                requiredTosList[tosId] && !checkedTosList[tosId]
            )

            return !isNotValid
        }

        setValid(validate())
    }, [checkedTosList])


    const updater = {
        isAllCheck: isAllCheck,
        checkedTosList: checkedTosList,
        toggleAllCheckbox() {
            setAllCheck(!isAllCheck)
        },
        toggleCheckbox(tosId) {
            const newCheckedTosList = { ...checkedTosList }

            newCheckedTosList[tosId] = !newCheckedTosList[tosId]

            setCheckedTosList(newCheckedTosList)
        },
        check(tosId) {
            const newCheckedTosList = {...checkedTosList}

            newCheckedTosList[tosId] = true

            setCheckedTosList(newCheckedTosList)
        }
    }

    return [updater, isValid]
}
